module.exports = __webpack_public_path__ + "static/media/valley_view.6cbea7ef.png";